namespace SorAraBul.Administration {
    export interface UserCreditPaymentOrderRow {
        Id?: number;
        PaymentCode?: string;
        UserId?: number;
        UserDisplayName?: string;
        UserEmail?: string;
        CompanyId?: number;
        CompanyName?: string;
        PurchasePackageId?: number;
        PurchasePackageName?: string;
        CreditCount?: number;
        Amount?: number;
        Status?: string;
        InsertDate?: string;
        PaidDate?: string;
        RawCallback?: string;
    }

    export namespace UserCreditPaymentOrderRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PaymentCode';
        export const localTextPrefix = 'Administration.UserCreditPaymentOrder';
        export const deletePermission = 'Administration:SuperAdmin';
        export const insertPermission = 'Administration:SuperAdmin';
        export const readPermission = 'Administration:SuperAdmin';
        export const updatePermission = 'Administration:SuperAdmin';

        export declare const enum Fields {
            Id = "Id",
            PaymentCode = "PaymentCode",
            UserId = "UserId",
            UserDisplayName = "UserDisplayName",
            UserEmail = "UserEmail",
            CompanyId = "CompanyId",
            CompanyName = "CompanyName",
            PurchasePackageId = "PurchasePackageId",
            PurchasePackageName = "PurchasePackageName",
            CreditCount = "CreditCount",
            Amount = "Amount",
            Status = "Status",
            InsertDate = "InsertDate",
            PaidDate = "PaidDate",
            RawCallback = "RawCallback"
        }
    }
}
